import { toast } from "sonner";

/**
 * Download a single asset in the requested format via the backend converter.
 * Works for uploaded storage-path assets, hotlinked seed URLs, and format
 * conversions (jpg/png/webp/pdf). Returns true on success.
 */
export async function downloadAssetFile(asset, format) {
  if (!asset || !asset.id) return false;
  const token = localStorage.getItem("apollo_token");
  const target = (format || asset.file_type || "").toString().toLowerCase();
  const label = target ? target.toUpperCase() : "file";
  const pending = toast.loading(`Preparing ${label}…`);
  try {
    const qs = target ? `?format=${encodeURIComponent(target)}` : "";
    const res = await fetch(
      `${process.env.REACT_APP_BACKEND_URL}/api/assets/${asset.id}/download-file${qs}`,
      { headers: { Authorization: token ? `Bearer ${token}` : "" } }
    );
    if (!res.ok) {
      const j = await res.json().catch(() => ({}));
      toast.error(j.detail || "Download failed", { id: pending });
      return false;
    }
    const disp = res.headers.get("content-disposition") || "";
    const match = disp.match(/filename="([^"]+)"/);
    const filename = match ? match[1] : `${asset.title || "asset"}.${target || "bin"}`;
    const blob = await res.blob();
    const objUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = objUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(objUrl), 1500);
    toast.success(`Downloaded ${filename}`, { id: pending });
    return true;
  } catch {
    toast.error("Download failed", { id: pending });
    return false;
  }
}
